import {css} from 'lit';
export const styles = css`:host {
  --background-primary: #fff;
  --background-hover: var(--gray-100);
  --background-active: var(--gray-300);
  --text-primary: var(--dark-text);

  display: block;
}

a {
  position: relative;
  display: flex;
  padding: 8px 16px;
  background-color: var(--background-primary);
  border-bottom: 1px solid var(--gray-new-100);
  border-radius: 8px 8px 0 0;
  color: var(--text-primary);
  font-size: var(--font-size-primary);
}

a.focus-visible {
  outline-offset: -4px;
}

a:focus-visible {
  outline-offset: -4px;
}

@media (hover: hover) {
  a:hover {
    background-color: var(--background-hover);
  }
}

a:active {
  background-color: var(--background-active);
}

ef-icon-block {
  --font-size-primary: 11px;

  text-transform: uppercase;
}
`;
export default styles;
